module.exports = __webpack_public_path__ + "img/sad.44bda2f3.svg";